import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import { SmallBadge } from 'components/common/Badge'
import { getFormattedAttackType } from 'utils/metadata'
import {
  getGraphNodesByType,
  scenarioGraphTypes
} from 'components/scenarios/utils/graph'
import { unique } from 'utils/list'
import theme from 'theme'
import { getScenarioCommands } from 'components/scenarios/utils'

export const TEXT_LIMIT = 2
export const ICON_LIMIT = 4

export function getUniqueScenarioCommands(scenario) {
  const statusChecks = getGraphNodesByType(
    scenario.graph,
    scenarioGraphTypes.SynchronousStatusCheck,
    scenarioGraphTypes.ContinuousStatusCheck
  ).map(() => 'status_check')
  const commands = getScenarioCommands(scenario)
  return unique([...statusChecks, ...commands])
}

export function ScenarioCommandIconsList({
  iconLimit,
  uniqueNodeCommands,
  iconSize,
  fontSize
}) {
  const overIconLimit = uniqueNodeCommands.length > iconLimit
  return (
    <div
      css={{
        display: 'inline-flex',
        flexDirection: 'row-reverse',
        color: theme.colors.steel[1]
      }}
    >
      {overIconLimit && (
        <SmallBadge
          css={{
            alignSelf: 'flex-start',
            background: theme.colors.steel[1],
            marginLeft: -theme.space[2],
            borderRadius: theme.borderRadius[1],
            paddingLeft: theme.space[2],
            paddingRight: theme.space[2]
          }}
        >
          +{uniqueNodeCommands.length - iconLimit}
        </SmallBadge>
      )}
      {uniqueNodeCommands
        .slice(0, iconLimit)
        .reverse()
        .map((command, i) => {
          return (
            <GlyphIcon
              key={command + i}
              backgroundColor={theme.colors.white[0]}
              css={{
                width: iconSize,
                height: iconSize,
                marginLeft: -theme.space[2],
                '& .glyph-circle': {
                  border: theme.border.base,
                  borderColor: theme.colors.gray[2]
                },
                '&:last-of-type': {
                  marginLeft: 0
                }
              }}
            >
              <AttackTypeIcon
                css={{
                  fontSize: fontSize,
                  color: theme.colors.steel[1]
                }}
                icon={command}
              />
            </GlyphIcon>
          )
        })}
    </div>
  )
}

ScenarioCommandIconsList.propTypes = {
  iconLimit: PropTypes.number,
  uniqueNodeCommands: PropTypes.array,
  iconSize: PropTypes.number,
  fontSize: PropTypes.number
}

ScenarioCommandIconsList.defaultProps = {
  iconSize: theme.space[4],
  fontSize: theme.fontSizes[1],
  iconLimit: ICON_LIMIT
}

export function ScenarioAttackTypeList({ scenario }) {
  const uniqueNodeCommands = getUniqueScenarioCommands(scenario)

  if (uniqueNodeCommands.length < 1) {
    return null
  }

  const overIconLimit = uniqueNodeCommands.length > ICON_LIMIT

  return (
    <div css={{ display: 'flex', alignItems: 'center' }}>
      <ScenarioCommandIconsList
        overIconLimit={overIconLimit}
        uniqueNodeCommands={uniqueNodeCommands}
      />
      {uniqueNodeCommands.length <= TEXT_LIMIT && (
        <Text as="h5" color="normal" css={{ marginLeft: theme.space[2] }}>
          {uniqueNodeCommands.map(getFormattedAttackType).join(' + ')}
        </Text>
      )}
    </div>
  )
}

ScenarioAttackTypeList.propTypes = {
  scenario: PropTypes.object
}
